/**
 * Chart Loading Skeleton
 * Generic skeleton component for chart loading states
 */

import React from 'react'
import { Skeleton } from '@/components/ui/skeleton'

interface ChartSkeletonProps {
  width?: number | string
  height?: number
}

export const ChartSkeleton: React.FC<ChartSkeletonProps> = ({
  width = '100%',
  height = 400
}) => {
  return (
    <div
      className="flex items-center justify-center bg-card rounded-lg p-4"
      style={{
        width: typeof width === 'string' ? width : `${width}px`,
        height: `${height}px`
      }}
    >
      <Skeleton
        className="w-full h-full rounded-lg"
        style={{
          backgroundColor: 'rgba(255, 255, 255, 0.05)'
        }}
      />
    </div>
  )
}
